import { CircularProgress } from '@mui/material'
import React from 'react'
import { LoadingContainer } from './components'
import { LoadingIndicatorProps } from './types'

function LoadingIndicator({ show, alignItems = 'flex-start', margin = '' }: LoadingIndicatorProps) {
  if (!show) {
    return null
  }
  
  return (
    <LoadingContainer alignItems={alignItems} margin={margin}>
      <CircularProgress />
    </LoadingContainer>
  )
}

export default LoadingIndicator
